import { classes } from "../../../omnia"
import { PlanContext } from "../../context"
import { ObservationsMgr } from "../../observations/manager"
import { SelectedFieldAction, SelectedFieldObservation } from "../../observations/types"
import { SaveFavorite } from "./SaveFavorite"
import { TextArea } from "./TextArea"

interface Props {

    obs: SelectedFieldObservation
    action: SelectedFieldAction

    mgr: ObservationsMgr

}

export function Action({ obs, action, mgr }: Props) {

    const placeholder = "Action related to this observation"

    const { dispatch } = React.useContext(PlanContext)

    const isActive = mgr.isActive(obs.key, action.key) && (!obs.deleted)

    const setHasFocus = (hasFocus: boolean) => {
        if (hasFocus) {
            dispatch({ type: "selectObservation", observation: obs.key, action: action.key })
        }
    }


    const isLastAction = obs.actions.indexOf(action) === (obs.actions.length - 1)
    const canAddNew = isLastAction && Boolean(action.text || action.actionId)
    const disabled = obs.deleted

    const update = (text: string) => {
        dispatch({ type: "updateAction", obs, key: action.key, text })
    }

    const add = () => {
        dispatch({ type: "addNewAction", obs })
    }

    return <div className={classes("action", canAddNew && "addnew", obs.deleted && "deleted", isActive && "active")}>

        <TextArea placeholder={placeholder} text={action?.text ?? ""} setText={update} active={isActive} disabled={disabled} setHasFocus={setHasFocus} />

        {
            isActive &&
            <SaveFavorite obs={obs} action={action} mgr={mgr} />
        }

        <button type="button" className="btn btn-addnew" title="New action" onClick={add} disabled={disabled}>
            <i className="fas fa-plus"></i>
        </button>

    </div>
}
